import React, { useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";

const CurrencySymbol = () => {
    const [currency, setCurrency] = useState({ symbol: "", name: "" });
    const [isEditing, setIsEditing] = useState(false);

    const handleSave = () => {
        setIsEditing(false);
        console.log("Saved currency:", currency);
    };

    return (
        <div className="main-content">
            <div className="page-content">
                <div className="container-fluid">
                    <div className="container mt-5">
                        <div className="d-flex justify-content-center">
                            <div className="card shadow rounded-lg" style={{ width: "30rem" }}>
                                <div className="card-body">
                                    <h3 className=" text-center ">Currency Management</h3>
                                    <hr />
                                    {!isEditing ? (
                                        <div className="d-flex flex-column align-items-center">
                                            <div className="text-center mb-3">
                                                <p className="mb-2">
                                                    <strong>Symbol:</strong>{" "}
                                                    <span className="text-primary">
                                                        {currency.symbol || "Not Set"}
                                                    </span>
                                                </p>
                                                <p>
                                                    <strong>Name:</strong>{" "}
                                                    <span className="text-primary">
                                                        {currency.name || "Not Set"}
                                                    </span>
                                                </p>
                                            </div>
                                            <button
                                                className="btn btn-primary btn-lg"
                                                onClick={() => setIsEditing(true)}
                                            >
                                                Edit Currency
                                            </button>
                                        </div>
                                    ) : (
                                        <form
                                            onSubmit={(e) => {
                                                e.preventDefault();
                                                handleSave();
                                            }}
                                        >
                                            <div className="mb-3">
                                                <label htmlFor="currencySymbol" className="form-label">
                                                    Currency Symbol
                                                </label>
                                                <input
                                                    type="text"
                                                    className="form-control shadow-sm rounded"
                                                    id="currencySymbol"
                                                    value={currency.symbol}
                                                    onChange={(e) =>
                                                        setCurrency({ ...currency, symbol: e.target.value })
                                                    }
                                                    maxLength={5}
                                                    placeholder="Enter symbol (e.g., $)"
                                                />
                                            </div>
                                            <div className="mb-3">
                                                <label htmlFor="currencyName" className="form-label">
                                                    Currency Name
                                                </label>
                                                <input
                                                    type="text"
                                                    className="form-control shadow-sm rounded"
                                                    id="currencyName"
                                                    value={currency.name}
                                                    onChange={(e) =>
                                                        setCurrency({ ...currency, name: e.target.value })
                                                    }
                                                    placeholder="Enter name (e.g., Dollar)"
                                                />
                                            </div>
                                            <div className="d-flex justify-content-end">
                                                <button
                                                    type="button"
                                                    className="btn btn-secondary btn-lg me-2 shadow-sm rounded"
                                                    onClick={() => setIsEditing(false)}
                                                >
                                                    Cancel
                                                </button>
                                                <button
                                                    type="submit"
                                                    className="btn btn-success btn-lg shadow-sm rounded"
                                                >
                                                    Save
                                                </button>
                                            </div>
                                        </form>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default CurrencySymbol;
